<template>
  <b-form-tags v-model="localModel" no-outer-focus v-bind="$attrs" class="px-0">
    <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
      <b-input-group aria-controls="list-tags-line">
        <input
          v-bind="inputAttrs"
          v-on="inputHandlers"
          placeholder="Nova Tag - Enter para adicionar"
          class="form-control"
        />
        <b-input-group-append>
          <b-button @click="addTag()" size="sm" variant="bagsis" class="px-3">
            <font-awesome-icon icon="plus" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-row
        id="list-tags-line"
        class="mb-0 py-2"
        no-gutters
        v-show="Array.isArray(tags) && tags.length > 0"
      >
        <b-badge
          class="bg-bagsis mr-1 mb-1 pl-3 border-0 py-1 text-nowrap"
          pill
          v-for="(tag, id) in tags"
          :key="'badge' + id"
          :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
        >
          {{ tag }}
          <b-button
            @click="removeTag(tag)"
            variant="bagsis"
            pill
            class="ml-1"
            size="sm"
          >
            <font-awesome-icon icon="close" />
          </b-button>
        </b-badge>
      </b-row>
    </template>
  </b-form-tags>
</template>
<script>
export default {
  name: "ListTags",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    localModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
